import React from 'react';
import { Layout, RoutesMenu, GetInfo } from '../../components';
import '../../assets/styles/containers/Routes.sass';

const Stage3 = () => {
  return (
    <div className="Stage3">
      <Layout bannerId={74}>
        <RoutesMenu/>
        <div className="container">
          <GetInfo id={141}/>
        </div>
      </Layout>
    </div>
  );
};

export default Stage3;
